// ----------------------------------------------------------------------
// <copyright file="Izenda.FieldTreeContainer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Field Data Tree Container component
 */
!(function() {

  var connect = require('share/enhancers/Izenda.Connect');

  var React = require('react');

  var SearchTextBox = require('share/components/controls/Izenda.SearchTextBox');
  var DataTree = require('../DataSourceTree/Izenda.DataSourceTree');
  var CalculatedField = require('share/components/controls/calculatedField/Izenda.CalculatedField');
  var constants = require('logic/data/Izenda.ReportDesignerConstants');

  var FieldTreeContainer = React.createClass({

    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    renderTopContent: function() {
      var localization = this.props.localization;
      function handleClickAddCalculatedField() {
        this.renderCalculatedField();
      }

      return (
          <div className='header-panel'>
            <a onClick={handleClickAddCalculatedField.bind(this)} className='overflow-text u_block'>
              <span className='icon-plus' />
              {localization.getText('COMMON_LABEL_ADD_CALCULATED_FIELD')}
            </a>
          </div>
      );
    },

    renderSearchBox: function() {
      var store = this.props.store;

      return (
        <div className='search-box'>
          <SearchTextBox
            value={store.dataTree.filterText}
            onChange={onChangeSearchText}/>
        </div>
      );

      function onChangeSearchText(e) {
        store.dataTree.filterText = e.target.value;
      }
    },

    closeCalculatedPopup: function(calculatedData) {
      var store = this.props.store;
      calculatedData && store.addCalculatedField(calculatedData);
    },

    renderCalculatedField: function() {
      var calculatedStore = this.props.store.calculatedStore;
      var masterModel = this.props.store.masterModel;
      var sourceId = calculatedStore.expressionSelection.getSelectedDataSourceId();
      this.props.store.fillCalculatedFieldData(null, null, true);
      this.props.openPopup(
        CalculatedField, {
          store: calculatedStore,
          onClose: this.closeCalculatedPopup,
          expressionConfig: constants.EXPRESSION_SELECTION.MIDDLE_FIELD,
          querySourceId: sourceId,
          isCheckDuplicateWithActualField: true,
          value: { previewRecord: masterModel.previewRecord}
        }
      );
    },

    render: function() {
      return (
        <section className='izenda-FieldTreeContainer u_fullHeight u-posRelative u-bgWhite'>
          <div className='izenda-MiddlePanel-search'>
            {this.renderTopContent()}
            {this.renderSearchBox()}
            <hr />
          </div>
          <DataTree
            className='izenda-MiddlePanel-content'
            store={this.props.store}
            useCheckBox={false}
            expandFieldLevel={true}
            uiStore={this.props.uiStore} />
        </section>
      );
    }
  });

  module.exports = connect()(FieldTreeContainer);
}());



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Izenda.FieldTreeContainer.jsx